import type { Editor } from '@tiptap/core'

import ProseMirrorStyle from '@/assets/styles/editor.css?inline'

let isMacResult: boolean | undefined
/**
 * Return true if the user is using a Mac (as opposed to Windows, etc.) device.
 */
export function isMac(): boolean {
  if (isMacResult === undefined) {
    isMacResult = navigator.userAgent?.includes('Mac')
  }
  return isMacResult
}

export function getShortcutKey(key: string): string {
  if (key.toLowerCase() === 'mod') {
    return isMac() ? '⌘' : 'Ctrl'
  } else if (key.toLowerCase() === 'alt') {
    return isMac() ? '⌥' : 'Alt'
  } else if (key.toLowerCase() === 'shift') {
    return isMac() ? '⇧' : 'Shift'
  } else {
    return key
  }
}

export function getShortcutKeys(keys: string[]): string {
  return keys.map(getShortcutKey).join(' ')
}

export function getSelectionText(editor: Editor): string {
  const { from, to, empty } = editor.state.selection
  if (empty) {
    return ''
  }
  return editor.state.doc.textBetween(from, to, '')
}

export function clamp(val: number, min: number, max: number): number {
  if (val < min) {
    return min
  }
  if (val > max) {
    return max
  }
  return val
}

export function hasExtension(editor: Editor, name: string): boolean {
  const { extensions = [] } = editor.extensionManager ?? {}

  const find = extensions.find(i => i.name === name)

  return Boolean(find)
}

export function buildPrintHTML(content: string, isPrint: boolean = false): string {
  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
        ${ProseMirrorStyle}
        * {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
      </style>
    </head>
    <body>
      <div class="ProseMirror ${isPrint ? 'tiptap-print' : ''}" translate="no"  aria-expanded="false">
        ${content}
      </div>
    </body>
    </html>`
}
